import { indexData } from '@/mocks/homeData';

export default function IndexSection() {
  return (
    <section id="index" className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            {indexData.title}
          </h2>
          <p className="text-sm md:text-base text-foreground-500">{indexData.subtitle}</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-7 gap-3">
          {indexData.items.map((item) => (
            <a
              key={item.label}
              href={item.href}
              className="flex flex-col items-center gap-3 p-5 rounded-xl bg-background-100 border border-background-200/60 hover:border-primary-200/60 hover:bg-primary-50/50 transition-all duration-200 cursor-pointer"
            >
              <div className="w-12 h-12 rounded-xl bg-primary-100 flex items-center justify-center">
                <i className={`${item.icon} text-xl text-primary-600`}></i>
              </div>
              <div className="text-center">
                <div className="text-sm font-medium text-foreground-800 whitespace-nowrap">
                  {item.label}
                </div>
                <div className="text-xs text-foreground-400 mt-1">{item.desc}</div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}